import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Upload } from 'antd';

export const StyledImage = styled.img`
  object-fit: contain;
  border: 1px solid ${COLORS.SOFT_GRAY};
`;

export const StyledUpload = styled(Upload)`
  display: flex;
  width: 100%;
`;

export const StyledUploadContent = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledPhotoInfo = styled.div`
  display: flex;
  margin-top: 0.125rem;
  ${pickThemeFontStyles('12', '22', 'NORMAL')};
`;
